export const MainHeaderDisabledRoutes = [
  '/callback',
  '/login',
  '/register',
  '/join/:referralCode',
  '/payment-launch/:any',
  '/payment-select/:any',
  '/games/launch/:any/:any',
  '/games/launch/:id',
  '/account/:any',
  '/account/:any/:any',
  '/interac-redirect',
].map((route) => ({ path: route }));

export const RouteHeaderDisabledRoutes = [
  '/',
  '/games',
  '/account',
  '/register',
  '/join/:referralCode',
  '/account/verify',
  '/callback',
  '/login',
  '/interac-redirect',
  '/prize-wall/winners',
  '/prize-wall/info',
  '/prize-wall',
]
  .filter((val) => !!val)
  .map((route) => ({ path: route }));

export const DisableBackButtonRoutes = ['/verifyInteracEmail'].map((route) => ({
  path: route,
}));

export const DefaultRouteTitles: { [key: string]: string } = {
  '/shop': 'Shop',
  '/rewards': 'Rewards',
  '/promos': 'Promos',
  '/quests': 'Quests',
  '/quests/:id': 'Quest',
  '/account/details': 'My profile',
  '/account/limits/timeout': 'Timeout',
  '/account/limits/loss': 'Loss Limit',
  '/account/limits/self-exclusion': 'Self-Exclusion',
  '/account/limits/playtime': 'Playtime Limit',
  '/account/multi-factor': 'Two-Factor Authentication',
  '/account/payment-history': 'Transaction history',
  '/account/game-transactions': 'Gaming transactions',
  '/account/coins-game-transactions': 'Coins gaming transactions',
  '/account/game-history': 'Gaming transactions',
  '/account/sessions': 'Sessions',
  '/account/notifications': 'Manage notifications',
  '/account/payment-result': 'Payment Status',
  '/account/payment-result-iframe': 'Payment Status',
  '/account/source-of-funds': 'SOF Attestation',
  '/games/:gameId': 'Game details',
  '/level-up': 'Level up',
  '/about': 'About us',
  '/contact': 'Contact us',
  '/privacy': 'Privacy Policy',
  '/terms': 'Terms of Use',
  '/status': 'Bonanza Status',
  '/verifyInteracEmail': 'Verification Status',
  '/play-with-coins': 'Play With Bonanza Coins',
  '/register': 'Create Bonanza Account',
};

export const DefaultBackButtonDestinations: { [key: string]: string } = {
  '/games': '/',
  '/promos': '/',
  '/promos/:id': '/promos',
  '/quests/:id': '/quests',
  '/quests': '/',
  '/account/limits/:any': '/account/limits',
  '/account/:any': '/account',
  '/games/:id': '/games',
  '/games/launch/:id': '/games',
  '/:categoryId': '/games',
  '/register': '/',
  'not-found': '/',
};
